import { Weekday } from '../types/contracts';

const all: Weekday[] = ['月', '火', '水', '木', '金', '土', '日'];

/**
 * 週の文字列配列を1つの文字列として繋げて生成する。
 * (ex: 毎週月,水,木)
 * 全ての曜日が該当する場合のみ 月 ~ 日 とする。
 * (ex: 毎週月~日)
 * @param days Weekday[]
 * @returns string
 */
export function getWeekDaysText(days: Weekday[]): string {
  if (days.length === 0) return '';
  // 月~日の場合のみ範囲形式の表示にする
  // @see https://project-fenrir.slack.com/archives/C04Q57G72E8/p1701420029713439?thread_ts=1701252770.320939&cid=C04Q57G72E8
  const s = new Set(days);
  const isAll = all.length === s.size && all.every((x) => s.has(x));
  return `毎週 ${isAll ? '月~日' : days.join(',')}`;
}
